import React from "react";
import { Phone, Mail, MapPin, MessageCircle, Instagram, Facebook, Clock } from "lucide-react";
import { BRAND, NAV_LINKS, SERVICES, OPENING_HOURS } from "../../mock";
import { Logo } from "./Navbar";

const Footer = () => (
  <footer className="border-t border-white/10 bg-[#08090b] pt-16">
    <div className="container-x grid gap-10 pb-12 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <Logo />
        <p className="mt-5 max-w-[260px] text-sm leading-relaxed text-white/50">Specialist car remapping, diagnostics and mobile workshop services across {BRAND.area}.</p>
        <div className="mt-6 flex gap-3">
          {[Instagram, Facebook, MessageCircle].map((I, i) => (
            <a key={i} href={i === 2 ? BRAND.whatsapp : "#top"} target={i === 2 ? "_blank" : undefined} rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white/70 transition-colors hover:border-brand hover:bg-brand hover:text-white"><I className="h-4 w-4" /></a>
          ))}
        </div>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.12em] text-white">Quick Links</h4>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => <li key={l.href}><a href={l.href} className="text-sm text-white/55 transition-colors hover:text-brand">{l.label}</a></li>)}
          <li><a href="#book" className="text-sm text-white/55 transition-colors hover:text-brand">Get a Quote</a></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.12em] text-white">Services</h4>
        <ul className="mt-5 space-y-3">
          {SERVICES.map((s) => <li key={s.title}><a href="#services" className="text-sm text-white/55 transition-colors hover:text-brand">{s.title}</a></li>)}
        </ul>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.12em] text-white">Contact EVTTuning UK</h4>
        <ul className="mt-5 space-y-4 text-sm text-white/60">
          <li><a href={BRAND.phoneHref} className="flex items-center gap-3 hover:text-brand"><Phone className="h-4 w-4 text-brand" />{BRAND.phone}</a></li>
          <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 hover:text-brand"><Mail className="h-4 w-4 text-brand" />{BRAND.email}</a></li>
          <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-brand" />{BRAND.area} Area</li>
          {OPENING_HOURS.map((o) => (
            <li key={o.days} className="flex items-start gap-3"><Clock className="mt-0.5 h-4 w-4 shrink-0 text-brand" /><span><span className="text-white/80">{o.days}</span><br />{o.hours}</span></li>
          ))}
        </ul>
        <a href="#book" className="btn-red mt-6 inline-block rounded-lg px-5 py-2.5 text-sm font-semibold">Book a Remap</a>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-[13px] text-white/40 sm:flex-row">
        <span>© {new Date().getFullYear()} EVTTuning UK. All rights reserved.</span>
        <span>Professional Car Remapping · {BRAND.area}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
